import { ActionReducerMap } from '@ngrx/store';
import { CreateGRNStateReducer } from './create-grn/create-grn.reducer';
import { MaterialRequestsStateReducer } from './material-requests/material-requests.reducer';
import { StorageStateReducer } from './storage/storage.reducer';
import { TransferStateReducer } from './transfer/transfer.reducer';
import {
  TCreateGrnStoreState,
  TStorageStoreState,
  TMaterialRequestStoreState,
  TTransferStoreState,
} from '@monorepo/types';

export type TOrganizi8AppState = {
  createGRN: TCreateGrnStoreState;
  storage: TStorageStoreState;
  materialRequests: TMaterialRequestStoreState;
  transfer: TTransferStoreState;
};

export const Organizi8AppStateReducer: ActionReducerMap<TOrganizi8AppState, never> = {
  createGRN: CreateGRNStateReducer,
  storage: StorageStateReducer,
  materialRequests: MaterialRequestsStateReducer,
  transfer: TransferStateReducer,
};
